module.exports = __webpack_public_path__ + "img/herb-parsley-190x100.c1413a73.jpg";